<template>
  <div class="block-overlay">
    <q-icon name="person" class="block-overlay__bg-icon" />
    <div class="block-overlay__content">
      <span>{{ $t('addMedia.blockedText') }}</span>
      <q-btn
        icon="login"
        color="primary"
        :label="$t('login.loginButton')"
        class="q-mt-sm"
        @click="goToLogin"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginOverlay',
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.block-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.45);
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;

  &__bg-icon {
    position: absolute;
    color: rgba(#fff, 0.2);
    z-index: 4;
    font-size: 250px;
  }
  span {
    color: white;
    font-size: 24px;
  }
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 6;
    justify-content: center;
  }
}

@media (max-width: 450px) {
  .block-overlay {
    span {
      font-size: 18px;
    }
  }
}
</style>